module.exports = __webpack_public_path__ + "static/media/Large_2017.414bec63.svg";